export const OPEN_NOTIFICATION = '[Notification]/OPEN_NOTIFICATION';
export const CLOSE_NOTIFICATION = '[Notification]/CLOSE_NOTIFICATION';

export const TOGGLE_ALERT_DIALOG = '[Notification]/TOGGLE_ALERT_DIALOG';
